import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/storage";

//add Firebase config here
const config = {
  // prod
  apiKey: "AIzaSyAUzrbhE5OHrZSrG03jViLZd_rcIGRpLrY",
  authDomain: "green-neighbours.firebaseapp.com",
  projectId: "green-neighbours",
  storageBucket: "green-neighbours.appspot.com",
  messagingSenderId: "868216104013",
  appId: "1:868216104013:web:898f33e3a2e6c9817a2804",
  measurementId: "G-8PDK891RRS"
  // dev
  // apiKey: "AIzaSyAUzrbhE5OHrZSrG03jViLZd_rcIGRpLrY",
  // authDomain: "green-neighbours.firebaseapp.com",
  // projectId: "green-neighbours",
  // storageBucket: "green-neighbours.appspot.com",
  // messagingSenderId: "868216104013",
  // appId: "1:868216104013:web:12b35ec4791eaff77a2804",
  // measurementId: "G-6NC2JGB7BF"
};

firebase.initializeApp(config);

firebase.analytics();
Vue.prototype.$analytics = firebase.analytics();

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage()

export { db, auth, storage, firebase };
